module.exports = __webpack_public_path__ + "img/upload-cloud.83ae95d2.svg";